import { SHOW_POPUP, HIDE_POPUP } from '../actions/actionTypes';

const initialState = {
  children: '',
  open: false,
  left: 0,
  top: 0,
};

export default function popup(state = initialState, action) {
  switch (action.type) {
    case SHOW_POPUP: {
      const { children, left, top } = action.payload;
      return {
        open: true,
        children,
        left,
        top,
      };
    }
    case HIDE_POPUP: {
      return {
        ...state,
        open: false,
      };
    }
    default:
      return state;
  }
}
